
export const environment = {
  production: true,
  envName: 'dev',
  baseUrl: 'https://ssv-dev.azure.chevron.com',
  apiUrl: 'https://ssv-api-dev.azure.chevron.com',
  wssUrl: 'wss://ssv-api-dev.azure.chevron.com',
  refreshUrl: 'https://go.chevron.com/ssv-dev',
  instrumentationKey: '',
  ctid: 'fd799da1-bfc1-4234-a91c-72b3a1cb9e26',
  reportId: 'ada3fc2c-40dc-42fb-849a-e1cce6e61345',
  groupId: 'bff08c11-0380-4544-841b-107566b4e49f',
  dsmReportId:'de591593-5fd9-4147-8d23-3f9bcc2d5ce4',
};

